/* eslint-disable react/display-name */
import React, { lazy, memo } from "react";

const CartPage = lazy(() => import("./pages/cart-manage"));
const ModuleSortingPage = lazy(() => import("./pages/module-sorting"));
const ScriptPage = lazy(() => import("./pages/script-manage"));
const ModuleXTeamModal = lazy(() => import("./pages/module-xteam"));
const ModuleSortingLogsPage = lazy(() => import("./pages/logs-manage"));
const DeviceManagePage = lazy(() => import("./pages/device-manage"));
const OtaManagePage = lazy(() => import("./pages/ota-manage"));
const DeviceMappingPage = lazy(() => import("./pages/mapping-device"));

const PutToLightRoutes = [
  { path: "cart", element: <CartPage /> },
  { path: "module-sorting", element: <ModuleSortingPage /> },
  { path: "script", element: <ScriptPage /> },
  { path: "module-xteam", element: <ModuleXTeamModal /> },
  { path: "logs", element: <ModuleSortingLogsPage /> },
  { path: "devices", element: <DeviceManagePage /> },
  { path: "ota", element: <OtaManagePage /> },
  { path: "mapping-devices", element: <DeviceMappingPage /> },
];

export default PutToLightRoutes;
